import tenantApi from '@api';
import { NetworkService } from '../../../../services/networkService';

const convertToAgency = async (values, userId) => {
  const response = await NetworkService.put(`/api/users/${userId}`, tenantApi.convertToAgencyPayload(values, userId));
  return response;
};
export default convertToAgency;
